"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetadataModel", {
    enumerable: true,
    get: function() {
        return MetadataModel;
    }
});
const _zod = require("zod");
const MetadataModel = _zod.z.object({
    __createdAt: _zod.z.string({
        description: 'The ISO date time the entity was created.'
    }).datetime(),
    __createdBy: _zod.z.string({
        description: 'The user id of the creating user.'
    }).uuid().optional(),
    __lastUpdatedAt: _zod.z.string({
        description: 'The ISO date time the entity was last updated.'
    }).datetime(),
    __lastUpdatedBy: _zod.z.string({
        description: 'The user id of the last updating user.'
    }).uuid().optional(),
    __deletedAt: _zod.z.string({
        description: 'The date time the instruction was deleted at.'
    }).datetime().optional(),
    __deletedBy: _zod.z.string({
        description: 'The user id of the deleting user.'
    }).uuid().optional(),
    __version: _zod.z.number({
        description: 'The current version of the entity.'
    }).int()
});

//# sourceMappingURL=metadata-model.js.map